import { render } from "./CategorySelect.vue?vue&type=template&id=4e131578&scoped=true&bindings={\"categories\":\"props\",\"selectedCategories\":\"props\",\"placeholder\":\"props\",\"isSelected\":\"options\",\"selectItem\":\"options\"}"
import script from "./CategorySelect.vue?vue&type=script&lang=js"
export * from "./CategorySelect.vue?vue&type=script&lang=js"

import "./CategorySelect.vue?vue&type=style&index=0&id=4e131578&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e131578"

export default script